import { useEffect, useMemo, useState } from 'react'
import PurchaseReportTable from '../components/PurchaseTables/PurchaseReportTable'
import { useFilterOnConsolidateAgreement } from '../../hooks/useFilterOnConsolidateAgreement'
import { useQuery } from 'react-query'
import { fetchPurchaseReport } from '../../../../api/api'
import { useChosenCompany } from '../../../../context/UserProvider'
import { Select } from '../../../cars/components/V3/_shared/Select'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import { ExcelExportButton } from '../components/ExcelExporter'
import { excelPurchaseReportColumns } from '../components/PurchaseTables/excelUtils'
import type { Purchase } from '../../../../types'

const PurchaseReport = () => {
  const company = useChosenCompany()
  const companyId = company?.id

  const [year, yearSet] = useState('')

  const { data: response, status } = useQuery(['purchaseReport', companyId], () => fetchPurchaseReport(companyId), {
    enabled: !!companyId,
  })

  const data = (Array.isArray(response) ? response : response && 'data' in response ? response.data : []) as Purchase[]

  const reportYears = useMemo(() => {
    return Array.from(new Set(data.map((el) => el.tyear)))
  }, [data])

  useEffect(() => {
    if (reportYears.length > 0 && year === '') {
      const newestYear = Math.max(...reportYears.map((y) => Number(y))).toString()
      yearSet(newestYear)
    }
  }, [reportYears, year])

  const items = [
    { value: 'all', label: 'Alle' },
    ...reportYears.map((year) => ({ value: String(year), label: String(year) })),
  ]

  const agreementFilter = useFilterOnConsolidateAgreement()
  const filteredData = data
    .filter((el) => year === 'all' || el.tyear === year)
    .filter(agreementFilter('consolidatedInvoiceAgreement'))
  const columns = excelPurchaseReportColumns()
  const config = { columns, filename: `Kjøpsrapport_${year}.xlsx`, sheetName: `Kjøpsrapport_${year}` }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between items-center">
          <span className="text-xl font-medium text-primaryText">Kjøpsrapport</span>
          <div className="md:hidden">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <Select className="h-11 w-full" placeholder={'Periode'} options={items} value={year} onChange={yearSet} />
          </div>
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
      </div>

      <PurchaseReportTable isLoading={status === 'loading'} data={filteredData} />
    </div>
  )
}

export default PurchaseReport
